/* eslint-disable react-hooks/exhaustive-deps */
import { ButtonStyled, FolderName, LinesWrapper, WrapperEmpty } from "./style";
import { DateTime } from "luxon";
import { EmptyContent } from "../../../../components/EmptyContent";
import { LoginModal } from "views/mobile/screens/LoginModal";
import { SignUpModal } from "views/mobile/screens/SignUpModal";
import { SkeletonLine } from "../../../../components/Loaders/SkeletonLine";
import { WrapperBack } from "../Calendar/style";
import { pathOr } from "ramda";
import { useAuth } from "hooks/useAuth";
import { useGetReservation } from "hooks/useGetReservation";
import { useGetReservationBlocksV3 } from "hooks/useGetReservationBlocksV3";
import CalendarComponent from "../Calendar";
import ConfirmReservation from "../ConfirmReservation";
import LineCard from "../../../../desktop/components/common/LineCard";
import LineFolder from "../../../../components/common/LineFolder";
import OfficeDesktopLayout from "views/components/OfficeDesktopLayout";
import OfficeProvider from "views/providers/OfficeProvider";
import React, { useEffect, useGlobal, useState } from "reactn";

const OfficeDetail = ({
	handleOnContinueReservationSteps,
	navToFolder,
	historyBack,
	handleOnSelectDate,
	reservationSteps,
	handleOnBack,
	step,
	user,
	loading,
	office,
	lines,
	linesByFolder,
	lineSelected,
	blockSelected,
	folders,
	folder,
	dateSelected,
	line,
	officeSlug,
	isActiveLoginModal,
	isDniRequired,
	isRutRequired,
	setIsRutModalVisible,
	setWantTemporary,
	ticketAction,
	handleOpenUpdateRutModal,
	closeSignUpModal,
	setOpenRutUpdate,
	handlerWithoutLoginModal,
	setIsVisibleConfirmationModal,
	signUpModalIsVisible,
	loginModalIsVisible,
	closeLoginModal,
	isActiveRegistryModal,
}) => {
	const [state, setState] = useState({
		keyBlocks: [],
	});
	const {
		handleCreateReservation,
		getReservationBlocks,
		blocks,
		loading: isLoading,
	} = useGetReservationBlocksV3({
		user,
	});
	const { isLoggedIn, isLoggedInTemporary } = useAuth();
	const { keyBlocks } = state;
	const [chosenTimeBlock, setChoosenTimeblock] = useState(null);
	const [fieldsAnswers, setFieldAnswers] = useState({});

	const [reservationsv3] = useGlobal("reservationsv3");

	const oldIdReservation = pathOr(
		false,
		["oldIdReservation"],
		reservationsv3
	);

	const [bookReservation] = useGetReservation(
		line && line.slug,
		officeSlug,
		line && line.id,
		false
	);

	useEffect(() => {
		if (isLoggedIn && step === reservationSteps.confirmReservation)
			handleReservationConfirm();
	}, [isLoggedIn]);

	useEffect(() => {
		if (blocks) {
			const lineSlugsByFolder = linesByFolder.map((item) => item.slug);
			const blockFormatted = Object.keys(blocks)
				.map((item) => {
					const linesByDay = blocks[item];
					const slugs = Object.keys(linesByDay).filter((lineSlug) => {
						const blocks =
							(linesByDay[lineSlug] &&
								linesByDay[lineSlug].blocks) ||
							[];

						return blocks.some((block) => block.slots > 0);
					});

					if (slugs.some((item) => lineSlugsByFolder.includes(item)))
						return {
							key: item,
							date: item.split("T").length
								? item.split("T")[0]
								: item,
						};

					return false;
				})
				.filter((item) => item);

			setState((prevState) => ({
				...prevState,
				keyBlocks: blockFormatted,
			}));
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [blocks]);

	const handleOnSelectLineToReservation = (line) => {
		handleOnContinueReservationSteps({ line });
	};

	const handleOnSelectDayCalendar = () => {
		const findBlock = keyBlocks.find((item) => item.date === dateSelected);
		const blockObj = blocks[findBlock.key];

		handleOnContinueReservationSteps({ blocks: blockObj });
	};

	const handleGetReservationBlocks = async ({ from, to }) => {
		await getReservationBlocks({
			officeSlug: office.slug,
			from,
			to,
			timezone: office.timezone || "America/Santiago",
			folder,
		});
	};

	function handleReservationConfirm() {
		const { 0: date = {} } = blockSelected.blocks || [];
		handleCreateReservation({
			lineSlug: lineSelected.slug,
			lineId: lineSelected._id,
			officeSlug: office.slug,
			from: date.from,
			to: date.to,
			oldIdReservation: oldIdReservation ? oldIdReservation : undefined,
		});
	}

	const handlerReservation = () => {
		return !isLoggedIn ? isActiveLoginModal() : handleReservationConfirm();
	};

	const checkIsDisabled = (office) => {
		return (
			pathOr(false, ["options", "office_disable", "active"], office) ||
			pathOr(false, ["options", "administrativeDeactivation"], office)
		);
	};

	return (
		<OfficeDesktopLayout
			user={user}
			office={office}
			userConfirmed
			title={
				step === reservationSteps.confirmReservation
					? "Confirmar reserva"
					: dateSelected && step === reservationSteps.showLines
					? `${folder} - ${DateTime.fromISO(dateSelected).toFormat(
							"dd LLL yyyy"
					  )}`
					: folder
					? "Seleccione una fecha"
					: !!lines.length &&
					  "Selecciona un trámite y únete a la fila"
			}
		>
			{checkIsDisabled(office) && (
				<h4
					style={{
						textAlign: "center",
						width: "100%",
						background: "#f0f0f0",
					}}
				>
					Sucursal no disponible
				</h4>
			)}
			<LinesWrapper gutter={[16, 32]} style={{ marginBottom: "18px" }}>
				{!folder &&
					folders.map((folder) => (
						<LineFolder
							key={folder}
							name={folder}
							categoryName={folder}
							officeSlug={office && office.slug}
							onClick={navToFolder(folder)}
							isDisabled={checkIsDisabled(office)}
						/>
					))}
				{!loading && folder && step === reservationSteps.calendar && (
					<>
						<FolderName>{folder}</FolderName>
						<CalendarComponent
							onBack={historyBack}
							onSelect={handleOnSelectDate}
							onContinue={handleOnSelectDayCalendar}
							dateSelected={dateSelected}
							onGetBlocks={handleGetReservationBlocks}
							isLoading={isLoading || loading}
							keyBlocks={keyBlocks}
							maxBookableDays={office.options.maxBookableDays}
							lines={lines}
							office={office}
							folder={folder}
						/>
					</>
				)}
				{step === reservationSteps.showLines &&
					lines
						.sort((a, b) => a.priority - b.priority)
						.map((line) => (
							<LineCard
								key={line.id}
								office={office}
								line={line}
								officeSlug={office && office.slug}
								onSelect={handleOnSelectLineToReservation}
							/>
						))}

				{step === reservationSteps.confirmReservation && (
					<ConfirmReservation
						office={office}
						line={lineSelected}
						onBack={handleOnBack}
						blockSelected={blockSelected}
						onConfirm={handlerReservation}
						isLoading={isLoading || loading}
					/>
				)}
				<LoginModal
					blockreservation={chosenTimeBlock}
					getReservation={bookReservation}
					handleMeet={() => false}
					handleOpenUpdateRutModal={handleOpenUpdateRutModal}
					isActiveLoginModal={isActiveLoginModal}
					isRutRequired={isRutRequired}
					isDniRequired={isDniRequired}
					isSignUpModalActive={isActiveRegistryModal}
					onClose={closeLoginModal}
					openRutUpdateModal={setOpenRutUpdate}
					openWithoutLoginModal={handlerWithoutLoginModal}
					setIsRutModalVisible={setIsRutModalVisible}
					setModalState={() => {}}
					setWantTemporary={setWantTemporary}
					ticketAction={ticketAction}
					visible={loginModalIsVisible}
					fieldsAnswers={fieldsAnswers}
					allowContinueWithTemp={false}
				/>
				<SignUpModal
					blockreservation={chosenTimeBlock}
					getReservation={bookReservation}
					handleMeet={() => false}
					handleOpenUpdateRutModal={handleOpenUpdateRutModal}
					isActive={isActiveLoginModal}
					onClose={closeSignUpModal}
					openRutUpdateModal={setOpenRutUpdate}
					openWithoutLoginModal={handlerWithoutLoginModal}
					setIsVisibleConfirmationModal={
						setIsVisibleConfirmationModal
					}
					ticketAction={ticketAction}
					visible={signUpModalIsVisible}
				/>

				{loading &&
					!lines.length &&
					loading.length > 0 &&
					[(0, 1)].map((_, i) => (
						<SkeletonLine
							style={{ margin: 12 }}
							key={i}
						></SkeletonLine>
					))}
				{!loading && !lines.length && !folders?.length && (
					<WrapperEmpty>
						<EmptyContent description="Esta oficina no tiene filas..."></EmptyContent>
					</WrapperEmpty>
				)}
			</LinesWrapper>
			{step === reservationSteps.showLines && (
				<WrapperBack>
					<ButtonStyled
						typeForStyled="backgroundless"
						onClick={handleOnBack}
					>
						Atrás
					</ButtonStyled>
				</WrapperBack>
			)}
		</OfficeDesktopLayout>
	);
};

export default OfficeProvider(OfficeDetail);
